// ─────────────────────────────────────────────────────────────────────────────
// ActivityTab.js — RECENT ACTIVITY timeline (dot + title + relative time).
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../UserDetailModal.module.css";

export default function ActivityTab({ detail }) {
  return (
    <div className={styles.tab}>
      <div className={styles.sectionLabel}>Recent Activity</div>
      <div className={styles.timeline}>
        {detail.activity.map((a, i) => (
          <div key={i} className={styles.timelineItem}>
            <span className={styles.timelineDot} />
            <div className={styles.timelineBody}>
              <span className={styles.timelineTitle}>{a.title}</span>
              <span className={styles.timelineTime}>{a.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
